export default __webpack_public_path__ + "static/media/planet6.7645b861.webp";